module.exports = __webpack_public_path__ + "img/x-gray.a0e8c426.svg";